import React from 'react';
import { useNavigate } from 'react-router-dom';

const landingImages = require.context('../../assets/images', true)


export const CourseCategoryCard = ({name, image, id}) => {
        const navigate = useNavigate();
    
        const categoryClick = (categoryId) => {
            console.log('CATEGRY CLICK', categoryId);
            navigate('/cursos',{state:{category: categoryId}});
        }
        return (
        <div className='col-12 col-sm-6 col-md-3 mt-3 CourseCategoryCard__clickable' 
            onClick={() => categoryClick(id)}>

                <div className='row mx-2 mt-2'>
                    <div className='col-12 p-0'>
                        <img src={landingImages(`./course_category/${image}`)} className='CourseCategoryCard__image' width="260" height="156" />                         
                    </div>
                </div>
                
                <div className='row justify-content-start align-items-center mx-2 mb-2 CourseCategoryCard__container-text'>
                    <div className='col-12 '>
                        <p className='CourseCategoryCard__text'>{name}</p>
                    </div>
                </div>

                
            
        </div>
    )
}
